/**
 * Mirrors an image horizontally using canvas
 * @param blob - The original image blob
 * @returns Promise<Blob> - The mirrored image blob, or original blob if mirroring fails
 */
export async function mirrorImage(blob: Blob): Promise<Blob> {
	return new Promise<Blob>((resolve) => {
		const img = new Image()
		const objectUrl = URL.createObjectURL(blob)
		
		img.onload = () => {
			try {
				const canvas = document.createElement('canvas')
				canvas.width = img.width
				canvas.height = img.height
				const ctx = canvas.getContext('2d')
				
				if (!ctx) {
					console.warn('Could not get canvas context, returning original blob')
					URL.revokeObjectURL(objectUrl)
					resolve(blob)
					return
				}
				
				// Mirror the image
				ctx.scale(-1, 1)
				ctx.drawImage(img, -img.width, 0)
				
				canvas.toBlob((mirroredBlob) => {
					if (mirroredBlob) {
						URL.revokeObjectURL(objectUrl)
						resolve(mirroredBlob)
					} else {
						console.warn('Could not create blob from canvas, returning original blob')
						URL.revokeObjectURL(objectUrl)
						resolve(blob)
					}
				})
			} catch (error) {
				console.warn('Error creating mirrored image, returning original blob:', error)
				URL.revokeObjectURL(objectUrl)
				resolve(blob)
			}
		}
		img.onerror = () => {
			console.warn('Error loading image for mirroring, returning original blob')
			URL.revokeObjectURL(objectUrl)
			resolve(blob)
		}
		img.src = objectUrl
	})
} 